import API from '@/lib/API.js'
import comun from './comun.js'
const nacionalidades = {
    namespaced: true,
    state: {
            Lista: [],
            Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined
        },
        set(state, payload) {
            state.Lista = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getNacionalidades();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Nacionalidades.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
    },
    getters: {
        getNacionalidades: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default nacionalidades;